import { Control, Controller } from "react-hook-form";

import { RelevanceScoreButtons } from "../../form_components/RelevanceScoreButtons";
import { NoticeFilters } from "../utils";

import css from "./SignalScore.module.scss";

export interface SignalScoreFilterContentProps {
  control: Control<NoticeFilters, unknown>;
}

function SignalScoreFilterContent({ control }: SignalScoreFilterContentProps) {
  return (
    <div className={css.filterSection} aria-label="Signals filters">
      <Controller
        name="relevanceScore"
        control={control}
        render={({ field }) => (
          <div className={css.inputContainer}>
            <RelevanceScoreButtons {...field} entityType="notice" />
          </div>
        )}
      />
    </div>
  );
}

export default SignalScoreFilterContent;
